// extracted by mini-css-extract-plugin
export var banner = "_hx-0";
export var closeButton = "_hx-2";
export var greenCheckmark = "_hx-3";
export var hereLink = "_hx-4";
export var titleIcon = "_hx-1";